export default function Terms() {
    return (
        <div className="max-w-[900px] mx-auto px-6 md:px-10 py-16" data-testid="terms-page">
            <div className="overline mb-3">Legal</div>
            <h1 className="font-display text-4xl md:text-5xl leading-tight">Terms of Use</h1>
            <div className="text-xs uppercase tracking-[0.12em] text-[#9a9a9a] mt-4">
                Last updated · {new Date().toLocaleDateString(undefined, { year: "numeric", month: "long" })}
            </div>

            <div className="report-prose mt-10 space-y-4">
                <p>
                    By creating an account or otherwise using SmartNote2Self License Risk Scan
                    ("the platform"), you agree to the following terms. If you do not agree, please
                    do not use the platform.
                </p>

                <h2>1. The service</h2>
                <p>
                    The platform is an independent Microsoft licensing maturity and procurement
                    readiness assessment tool. It generates an advisory executive report from the
                    inputs you provide. We are not Microsoft, not a reseller, and we do not
                    recommend specific vendors.
                </p>

                <h2>2. No legal, compliance or contractual advice</h2>
                <p>
                    The platform does <strong>not</strong> provide legal advice, licensing
                    compliance certification, contractual interpretation, or procurement approval.
                    Reports are an aid to internal decision-making only. Every licensing decision
                    must be validated against current Microsoft Product Terms, your applicable
                    agreements, and your own procurement requirements.
                </p>

                <h2>3. AI-generated content</h2>
                <p>
                    Reports are produced by a large language model (Anthropic Claude). Outputs may
                    occasionally be incomplete, contain errors, or omit material details. You are
                    responsible for reviewing reports before relying on them and for verifying any
                    Microsoft entitlement, SKU, or capability statement against authoritative
                    Microsoft documentation.
                </p>

                <h2>4. Your responsibilities</h2>
                <ul>
                    <li>Provide accurate information when registering and when answering the assessment.</li>
                    <li>Keep your password confidential.</li>
                    <li>Use the platform lawfully and only for your own organisation's benefit.</li>
                    <li>Do not attempt to misuse the platform, automate scraping, or interfere with other users.</li>
                </ul>

                <h2>5. Account and data deletion</h2>
                <p>
                    You may delete your account and all associated assessments at any time from your
                    dashboard. Deletion is immediate and irreversible.
                </p>

                <h2>6. Intellectual property</h2>
                <p>
                    The platform, its design and codebase are owned by SmartNote2Self. The content
                    of your assessments and the resulting reports are your property, subject to
                    these terms and the platform's privacy notice.
                </p>

                <h2>7. Disclaimer of warranties</h2>
                <p>
                    The platform is provided "as is" without warranties of any kind, express or
                    implied. We do not guarantee specific licensing outcomes, savings, or
                    procurement results.
                </p>

                <h2>8. Limitation of liability</h2>
                <p>
                    To the maximum extent permitted by law, SmartNote2Self shall not be liable for
                    any indirect, incidental, special, consequential or punitive damages, or for any
                    loss of profits, revenue, data or business opportunity arising from your use of
                    the platform.
                </p>

                <h2>9. Independence</h2>
                <p>
                    SmartNote2Self is independent. We do not represent Microsoft, do not represent
                    any reseller, and do not receive vendor compensation for the recommendations or
                    observations in any report.
                </p>

                <h2>10. Changes</h2>
                <p>
                    We may update these terms from time to time. Material changes will be reflected
                    on this page with a new "last updated" date.
                </p>

                <h2>11. Contact</h2>
                <p>
                    Questions about these terms?{" "}
                    <a href="mailto:smartmarcelle@gmail.com" className="text-[#00A896]">
                        smartmarcelle@gmail.com
                    </a>
                    .
                </p>
            </div>
        </div>
    );
}
